import { gql } from '@apollo/client';
import {
  sharedInvoiceInput,
  sharedInvoiceInputFields,
} from '../../fragments/invoice-input';

const OFFERS_DATE_INFORMATION = gql`
  query offersDateInformation(${sharedInvoiceInputFields}) {
    invoices(${sharedInvoiceInput}) {
      totalCount
      edges {
        cursor
        node {
          id
          dateIssued
          dateExpiration
          offer {
            fundingDaysAfterExpiration
          }
        }
      }
    }
  }
`;

export default OFFERS_DATE_INFORMATION;
